/**
 * Default language dictionary
 */
const defaultLanguage = {
  chat: 'Chat',
  'chat.new': 'New',
  participants: 'Participants',
  polls: 'Polls',
  plugins: 'Plugins',
  mic_off: 'Mic Off',
  mic_on: 'Mic On',
  video_off: 'Video Off',
  video_on: 'Video On',
  left_meeting: 'You left the meeting',
  share_screen_start: 'Share Screen',
  share_screen_stop: 'Stop Sharing',
  leave: 'Leave',
  dismiss: 'Dismiss',
  page: 'Page',
  settings: 'Settings',
  audio: 'Audio',
  video: 'Video',
  connection: 'Connection',
  leave_confirmation: 'Are you sure you want to leave the call?',
  end_meeting_for_all: 'End meeting for all',
  cancel: 'Cancel',
  yes: 'Yes',
  you: 'you',
  mute: 'Mute',
  kick: 'Kick',
  'participant.turn_off_video': 'Turn off video',
  perm_browser_denied: 'Permission denied by browser',
  'perm.sys_denied.message': "To enable system permission, go to Mac's System Preferences -> Security & Privacy ->  Privacy -> Select Microphone, Camera or 'Screen Recording' and allow permission for your specific browser",
  'perm_sys_denied.audio': 'Mic permission denied by system',
  'perm_sys_denied.video': 'Camera permission denied by system',
  'perm_sys_denied.screenshare': 'Screenshare permission denied by system',
  'perm_denied_title.video': 'Camera permission denied',
  'perm_denied_title.audio': 'Mic permission denied',
  'perm_denied_title.screenshare': 'Screenshare permission denied',
  'perm_denied_text.audio': 'It seems like your browser or system has blocked permission for us to access microphone. Please allow this permission and reload for a smoother experience.',
  'perm_denied_text.video': 'It seems like your browser or system has blocked permission for us to access camera. Please allow this permission and reload for a smoother experience.',
  'perm_denied_text.screenshare': 'It seems like your browser or system has blocked permission for us to screenshare. Please allow this permission and reload for a smoother experience.',
  full_screen: 'Full Screen',
  'full_screen.exit': 'Exit Full Screen',
  'waitlist.header_title': 'Waiting',
  'waitlist.body_text': 'You are in the waiting room, the host will let you in soon.',
  'waitlist.deny_request': 'Deny request',
  'waitlist.accept_request': 'Accept request',
  'waitlist.accept_all': 'Accept all',
  'stage_request.header_title': 'Join Stage Requests',
  'stage_request.deny_request': 'Deny request',
  'stage_request.accept_request': 'Accept request',
  'stage_request.accept_all': 'Accept all',
  'stage_request.deny_all': 'Deny all',
  'stage_request.approval_pending': 'Pending',
  'stage_request.denied': 'Denied',
  'stage_request.request': 'Join stage',
  'stage_request.cancel_request': 'Cancel request',
  'stage_request.leave_stage': 'Leave stage',
  'stage_request.request_tip': 'Request to join the discussion',
  'stage_request.leave_tip': 'Leave the stage',
  'stage_request.pending_tip': 'Request pending',
  'stage_request.denied_tip': 'Rejected request',
  'stage.empty_host': 'The stage is empty',
  'stage.empty_host_summary': 'To begin the webinar, please join the stage or accept a join stage request from the participants tab.',
  'stage.empty_viewer': 'Webinar has not yet been started',
  'stage.remove_from_stage': 'Remove from stage',
  'stage.add_to_stage': 'Add to stage',
  'stage.join_title': 'Join Stage',
  'stage.join_summary': 'You are about to join the stage, your video & audio as shown above will be visible to all participants.',
  'stage.join_cancel': 'Cancel',
  'stage.join_confirm': 'Join',
  'setup_screen.join_in_as': 'Join in as',
  'setup_screen.joining_as': 'Joining as',
  'setup_screen.your_name': 'Your name',
  'stage.reconnecting': 'Reconnecting...',
  pip_on: 'Show PiP',
  pip_off: 'Hide PiP',
  'recording.started': 'This meeting is being recorded.',
  'recording.stopped': 'Recording for this meeting has been stopped.',
  mute_all: 'Mute all',
  'mute_all.description': 'Everyone in the meeting will be muted',
  'mute_all.header': 'Are you sure?',
  'mute_all.allow_unmute': 'Allow others to unmute',
  'participants.empty_search_results': "Couldn't find a participant with the specified name or ID.",
  'participants.empty_list': 'It looks like nobody is here.',
  audio_playback: 'Play Audio',
  'audio_playback.title': 'Allow Audio Playback',
  'audio_playback.description': 'In order to play audio properly on your device, click the button below.',
  join: 'Join',
  joined: 'Joined',
  create: 'Create',
  close: 'Close',
  'confirmation_modal.header': 'Are you sure?',
  breakout_rooms: 'Breakout Rooms',
  'breakout_rooms.room_config_header': 'Create Breakout',
  'breakout_rooms.join_breakout_header': 'Join Breakout',
  'breakout_rooms.empty': 'Nobody here yet.',
  'breakout_rooms.switch': 'Switch',
  'breakout_rooms.main_room': 'Main Room',
  'breakout_rooms.shuffle_participants': 'Shuffle Participants',
  'breakout_rooms.deselect': 'Deselect',
  'breakout_rooms.selected': 'selected',
  'breakout_rooms.num_of_rooms': 'No. of Rooms',
  'breakout_rooms.approx': 'Approx.',
  'breakout_rooms.participants_per_room': 'participants/room',
  'breakout_rooms.division_text': 'when equally divided.',
  'breakout_rooms.start_breakout': 'Start Breakout',
  'breakout_rooms.close_breakout': 'Close Breakout',
  'breakout_rooms.update_breakout': 'Update Breakout',
  'breakout_rooms.discard_changes': 'Discard Changes',
  'breakout_rooms.room': 'Room',
  'breakout_rooms.rooms': 'Rooms',
  'breakout_rooms.room_name': 'Room Name',
  'breakout_rooms.edit_room_name': 'Edit Room Name',
  'breakout_rooms.save_room_name': 'Save Room Name',
  'breakout_rooms.add_room': 'Add',
  'breakout_rooms.add_room_brief': 'Add Room',
  'breakout_rooms.select_all': 'Select all',
  'breakout_rooms.unassign_all': 'Unassign all',
  'breakout_rooms.assign': 'Assign',
  'breakout_rooms.assign_participants': 'Assign Participants',
  'breakout_rooms.none_assigned': 'No participants assigned yet',
  'breakout_rooms.drag_drop_participants': 'Drag and drop participants',
  'breakout_rooms.click_drop_participants': 'Click here to assign',
  'breakout_rooms.status.assign_multiple': 'Assign multiple participants at once by clicking and selecting them',
  'breakout_rooms.status.select_room': 'Select a room to assign',
  'breakout_rooms.ephemeral_status.participants_assigned': 'Participants assigned',
  'breakout_rooms.ephemeral_status.participants_assigned_randomly': 'Participants assigned randomly',
  'breakout_rooms.ephemeral_status.changes_discarded': 'Changes discarded',
  'breakout_rooms.confirm_modal.start_breakout.header': 'Start breakout rooms?',
  'breakout_rooms.confirm_modal.start_breakout.content': 'Once started, all participants will be moved to their assigned rooms.',
  'breakout_rooms.confirm_modal.start_breakout.cancelText': 'No, go back',
  'breakout_rooms.confirm_modal.start_breakout.ctaText': 'Yes, start',
  'breakout_rooms.confirm_modal.close_breakout.header': 'Close breakout rooms?',
  'breakout_rooms.confirm_modal.close_breakout.content': 'All breakout rooms will be closed & participants will be moved back to the main room.',
  'breakout_rooms.confirm_modal.close_breakout.ctaText': 'Yes, close breakout',
  'breakout_rooms.move_reason.started_msg': 'Starting breakout rooms...',
  'breakout_rooms.move_reason.started_desc': 'You are being moved to your assigned room',
  'breakout_rooms.move_reason.closed_msg': 'Closing Breakout rooms...',
  'breakout_rooms.move_reason.closed_desc': 'You are being moved back to the main room',
  'breakout_rooms.move_reason.switch_room': 'Joining Breakout Room...',
  'breakout_rooms.move_reason.switch_main_room': 'Joining Main Room...',
  'breakout_rooms.all_assigned': 'All participants have been assigned',
  'breakout_rooms.empty_main_room': 'No more participants in the main room.',
  'breakout_rooms.leave_confirmation': 'Are you sure you want to leave the call? You are in a breakout room, you can join the main room too.',
  'breakout_rooms.leave_confirmation.main_room_btn': 'Go back to main room',
};

/**
 * Creates an i18n instance from a language dictionary/object.
 * @param lang The language dictionary
 * @returns A function which handles i18n
 */
const useLanguage = (lang = defaultLanguage) => {
  return (key) => {
    var _a;
    return (_a = lang[key]) !== null && _a !== void 0 ? _a : key;
  };
};

export { defaultLanguage as d, useLanguage as u };
